(function () {
  // ---------------------------------------------------------------------
  // Guard: this file gets re-inserted into the page every time the Quick
  // View modal content is fetched, because it never told the theme's
  // "safe-load-scripts" loader that it was already on the page. That
  // caused a brand new copy of this script (and a brand new click
  // listener below) to be added on every Quick View open, which is why
  // clicking SIZE GUIDE could open the SmartSize popup two (or more)
  // times at once.
  //
  // Fixing it two ways so it's safe even if it somehow still gets
  // injected twice:
  //   1. Register with the theme's script registry so safe-load-scripts
  //      stops appending new copies after the first load.
  //   2. Bail out immediately if our click listener is already bound.
  // ---------------------------------------------------------------------
  if (window.wetheme && window.wetheme.webcomponentRegistry) {
    window.wetheme.webcomponentRegistry.register({ key: 'smartsize-quickview' });
  }

  if (window.__smartsizeQuickviewBound) {
    return;
  }
  window.__smartsizeQuickviewBound = true;

  var SMARTSIZE_URL = 'https://cdn.shopify.com/extensions/019ed6af-e277-7528-b2d6-807bb0befd93/fitting-rooms-237/assets/smartsize-script.js';

  // Shared promise so two near-simultaneous calls never inject the
  // SmartSize widget script twice and race each other.
  var smartSizeScriptPromise = null;

  function loadSmartSizeScript() {
    if (document.querySelector('script[src*="smartsize-script"]')) {
      return Promise.resolve();
    }
    if (smartSizeScriptPromise) {
      return smartSizeScriptPromise;
    }
    smartSizeScriptPromise = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = SMARTSIZE_URL;
      s.onload = function () { resolve(); };
      document.head.appendChild(s);
    });
    return smartSizeScriptPromise;
  }

  function sfxOpen() {
    var trigger = document.querySelector('.smartsize-trigger:not(#ThemeModal .smartsize-trigger)');
    if (trigger) {
      trigger.click();
      return;
    }
    var t = document.createElement('div');
    t.className = 'smartsize-trigger smartsize-trigger--inline';
    t.style.cssText = 'position:fixed;top:-9999px;opacity:0;pointer-events:none;';
    document.body.appendChild(t);
    setTimeout(function () {
      t.click();
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 500);
    }, 300);
  }

  function openSmartSize(btn) {
    var d = window.sizefox = window.sizefox || {};
    d.data = d.data || {};
    d.data.product     = btn.getAttribute('data-sfx-product');
    d.data.productname = btn.getAttribute('data-sfx-productname');
    d.data.type        = btn.getAttribute('data-sfx-type');
    d.data.tags        = btn.getAttribute('data-sfx-tags');
    d.data.collections = btn.getAttribute('data-sfx-collections');
    d.shop             = btn.getAttribute('data-sfx-shop');

    loadSmartSizeScript().then(function () {
      setTimeout(sfxOpen, 500);
    });
  }

  // Debounce: ignore a second trigger while one open is still in flight,
  // so a single click can never result in two popups.
  var isOpening = false;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sizefox-size-guide-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (isOpening) return;
    isOpening = true;
    openSmartSize(btn);
    setTimeout(function () { isOpening = false; }, 1500);
  }, true);

})();